module.exports = __webpack_public_path__ + "assets/img/smartProductBg2.a03b59b1.png";